var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16663 11.0834C3.16663 6.71116 6.71104 3.16675 11.0833 3.16675H26.9166C31.2889 3.16675 34.8333 6.71116 34.8333 11.0834V26.9167C34.8333 31.289 31.2889 34.8334 26.9166 34.8334H11.0833C6.71104 34.8334 3.16663 31.289 3.16663 26.9167V11.0834ZM11.0833 6.33341C8.45994 6.33341 6.33329 8.46006 6.33329 11.0834V26.9167C6.33329 29.5401 8.45994 31.6667 11.0833 31.6667H26.9166C29.54 31.6667 31.6666 29.5401 31.6666 26.9167V11.0834C31.6666 8.46006 29.54 6.33341 26.9166 6.33341H11.0833Z",
    fill: "#00B0E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6926 17.0951C20.6926 18.467 20.6981 19.8371 20.6907 21.2091C20.6851 22.2765 20.0242 23.0247 19.0069 23.1417C18.0415 23.2512 17.091 22.4696 17.0186 21.5005C17.0037 21.2982 17.0037 21.094 17.0037 20.8897C17 18.2572 17 15.6266 17 12.9959C17.0019 12.012 17.5031 11.3102 18.3608 11.0689C19.4691 10.757 20.6425 11.5571 20.6722 12.7044C20.7093 14.1674 20.6814 15.6321 20.6814 17.0951C20.6851 17.0951 20.6889 17.0951 20.6926 17.0951Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6889 26.0191C20.6889 27.0402 19.8461 27.8831 18.8361 27.8701C17.8225 27.8571 17.0075 27.0346 17.0056 26.0229C17.0038 25.0018 17.8485 24.1571 18.8584 24.1701C19.8702 24.1831 20.6889 25.0092 20.6889 26.0173V26.0191Z",
    fill: "#00B0E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.69443,
    height: 16.87,
    fill: "white",
    transform: "translate(17 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconAlert);
export default __webpack_public_path__ + "static/media/modal-icon-alert.74b8f45e47421a7f7ad3b39f78560bf5.svg";
export { ForwardRef as ReactComponent };